
<n-simple-modal-body :title="title" :closable="false" @close="close()">
  <main><slot /></main>
  <template #rightFooter>
    <n-button
      v-if="variant === 'confirm'"
      variant="secondary"
      @click="onCancelClick"
      :label="$t('general.cancel')"
      :disabled="confirmLoading"
    />
    <n-button
      @click="$emit('confirm')"
      :label="confirmButtonText || $t('general.ok')"
      :icon="confirmButtonIcon"
      :loading="confirmLoading"
      :disabled="confirmLoading"
    />
  </template>
</n-simple-modal-body>
